// SSR utility functions

export const isServer = typeof window === 'undefined';
export const isBrowser = typeof window !== 'undefined';

/**
 * Safely access localStorage with SSR guard
 */
export function safeLocalStorage(key: string, defaultValue: any = null) {
  if (isBrowser && window.localStorage) {
    try {
      return localStorage.getItem(key) || defaultValue;
    } catch (err) {
      console.error('localStorage access error:', err);
      return defaultValue;
    }
  }
  return defaultValue;
}

/**
 * Safely execute browser-only code
 */
export function safeWindow<T>(callback: () => T, fallback: T): T {
  if (isBrowser) {
    try {
      return callback();
    } catch (err) {
      console.error('Window API error:', err);
      return fallback;
    }
  }
  return fallback;
}
